import React, { Suspense, lazy } from 'react';
import { Navigate, Link } from 'react-router-dom';
import useAdminMetrics from './hooks/useAdminMetrics';
import StatPanels from './components/StatPanels';
import './styles/admin.css';

// The canvas is the only importer of pixi.js (~100 kB gzipped). Code-split it
// so the main bundle every parent downloads doesn't carry the engine, and so
// a non-admin (403 → redirect) never fetches the chunk at all.
const VillageCanvas = lazy(() => import('./components/VillageCanvas'));

/**
 * /admin — the gamified "village" wall dashboard.
 *
 * Frontend-only feature, self-contained under src/admin. Admin-ness is not a
 * frontend flag: the page asks GET /api/admin/metrics with the normal token
 * and a 403 sends the user home. The PixiJS scene is only loaded and mounted
 * once the first successful response is in, so non-admins never initialise
 * WebGL (or download pixi).
 */
export default function AdminVillage() {
  const { data, error, lastUpdated, forbidden, loading } = useAdminMetrics();

  if (forbidden) return <Navigate to="/" replace />;

  const activeCount = data?.now?.activeCount ?? 0;

  return (
    <div className="admin-village">
      {data && (
        <Suspense fallback={null}>
          <VillageCanvas activeCount={activeCount} />
        </Suspense>
      )}
      {!data && (
        <div className="admin-village__status" role="status">
          <span>{loading ? 'Laster landsbyen…' : 'Kunne ikke hente tallene. Prøver igjen om ett minutt.'}</span>
          <Link to="/home" className="admin-village__status-link">← Tilbake til Coord</Link>
        </div>
      )}
      {data && <StatPanels data={data} lastUpdated={lastUpdated} stale={Boolean(error)} />}
    </div>
  );
}
